// Notification sound generator using Web Audio API
// Each sound is synthesized on-the-fly, no audio files needed

let audioContext = null;

const getAudioContext = () => {
  if (!audioContext || audioContext.state === 'closed') {
    audioContext = new (window.AudioContext || window.webkitAudioContext)();
  }
  if (audioContext.state === 'suspended') {
    audioContext.resume();
  }
  return audioContext;
};

const playTone = (frequency, duration, type = 'sine', volume = 0.3) => {
  const ctx = getAudioContext();
  const osc = ctx.createOscillator();
  const gain = ctx.createGain();
  osc.type = type;
  osc.frequency.setValueAtTime(frequency, ctx.currentTime);
  gain.gain.setValueAtTime(volume, ctx.currentTime);
  gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + duration);
  osc.connect(gain);
  gain.connect(ctx.destination);
  osc.start(ctx.currentTime);
  osc.stop(ctx.currentTime + duration);
};

export const NOTIFICATION_SOUNDS = {
  default: {
    name: 'Default',
    play: () => {
      playTone(880, 0.15, 'sine', 0.4);
      setTimeout(() => playTone(1100, 0.2, 'sine', 0.3), 150);
    }
  },
  chime: {
    name: 'Chime',
    play: () => {
      playTone(523, 0.12, 'sine', 0.3);
      setTimeout(() => playTone(659, 0.12, 'sine', 0.3), 120);
      setTimeout(() => playTone(784, 0.25, 'sine', 0.25), 240);
    }
  },
  bell: {
    name: 'Bell',
    play: () => {
      const ctx = getAudioContext();
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.type = 'sine';
      osc.frequency.setValueAtTime(1200, ctx.currentTime);
      osc.frequency.exponentialRampToValueAtTime(600, ctx.currentTime + 0.5);
      gain.gain.setValueAtTime(0.4, ctx.currentTime);
      gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + 0.5);
      osc.connect(gain);
      gain.connect(ctx.destination);
      osc.start(ctx.currentTime);
      osc.stop(ctx.currentTime + 0.5);
    }
  },
  ping: {
    name: 'Ping',
    play: () => {
      playTone(1500, 0.08, 'sine', 0.35);
      setTimeout(() => playTone(1500, 0.08, 'sine', 0.2), 120);
    }
  },
  pop: {
    name: 'Pop',
    play: () => {
      const ctx = getAudioContext();
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.type = 'sine';
      osc.frequency.setValueAtTime(400, ctx.currentTime);
      osc.frequency.exponentialRampToValueAtTime(1200, ctx.currentTime + 0.05);
      osc.frequency.exponentialRampToValueAtTime(800, ctx.currentTime + 0.1);
      gain.gain.setValueAtTime(0.5, ctx.currentTime);
      gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + 0.15);
      osc.connect(gain);
      gain.connect(ctx.destination);
      osc.start(ctx.currentTime);
      osc.stop(ctx.currentTime + 0.15);
    }
  },
  none: {
    name: 'None (Silent)',
    play: () => {}
  }
};

// Sent message sound - short subtle tick
export const playSentSound = () => {
  playTone(1000, 0.05, 'sine', 0.15);
};

export const playNotificationSound = (ringtoneId = 'default') => {
  const sound = NOTIFICATION_SOUNDS[ringtoneId] || NOTIFICATION_SOUNDS.default;
  sound.play();
};

// Vibrate if supported
export const vibrateDevice = (pattern = [100, 50, 100]) => {
  if (navigator.vibrate) {
    navigator.vibrate(pattern);
  }
};
